import { Cached, Download } from "@mui/icons-material";
import { Box, Button, IconButton, Typography } from "@mui/material";
import MUIDataTable from "mui-datatables";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useUserContext } from "../../context/UserContext";
import Body from "../../layouts/Body";
import {
  downloadDocument,
  getActivitiesByMentorId,
} from "../../utils/services";
import FssSupportForm from "./FssSuportForm";

const FssSupport = () => {
  const [supportData, setSupportData] = useState([]);
  const [open, setOpen] = useState(false);
  const { user } = useUserContext();

  const getSupportActivities = async () => {
    try {
      const response = await getActivitiesByMentorId(user.token, user.id);
      if (response.status === 200) {
        setSupportData(response.data);
        enqueueSnackbar("Support activities fetched successfully!", {
          variant: "success",
        });
      } else if (response.status === 404) {
        setSupportData([]);
        enqueueSnackbar("No data found", { variant: "info" });
      }
    } catch (err) {
      enqueueSnackbar("Error fetching mentor activities", { variant: "error" });
    }
  };

  useEffect(() => {
    getSupportActivities();
  }, []);

  const columns = [
    { name: "activityType", label: "FSS Support Type" },
    { name: "activityDate", label: "Date of Intervention/Support" },
    { name: "activityDuration", label: "Duration (in minutes)" },
    { name: "noOfAttendees", label: "Number of Attendees" },
    {
      name: "docId",
      label: "Document",
      options: {
        customBodyRender: (value) => (
          <IconButton
            onClick={() => downloadDocument(value, user.token)}
            disabled={!value}
            color="primary"
            sx={{ p: 0 }}
          >
            <Download />
          </IconButton>
        ),
      },
    },
    // {
    //   name: "menteeIds",
    //   label: "Mentee IDs",
    //   options: {
    //     customBodyRender: (value) => {
    //       if (!value) return ""; // handle case where menteeIds is empty

    //       return value
    //         .split(",")
    //         .map((menteeId) => menteeList.find((mentee) => mentee.id == menteeId)?.name || menteeId)
    //         .join(", ");
    //     },
    //   }
    // },
  ];

  return (
    <Body>
      <Box
        style={{ display: "flex", justifyContent: "space-between" }}
        sx={{ mb: 2 }}
      >
        <Typography variant="h5" color="primary" className="page-title">
          FSS Support
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
        >
          New
        </Button>
      </Box>

      <MUIDataTable
        title="FSS Support"
        data={supportData}
        columns={columns}
        options={{
          selectableRows: "none",
          print: false,
          viewColumns: false,
          customToolbar: () => (
            <IconButton onClick={getSupportActivities}>
              <Cached />
            </IconButton>
          ),
        }}
      />

      <FssSupportForm
        open={open}
        setOpen={setOpen}
        onSubmit={getSupportActivities}
      />
    </Body>
  );
};

export default FssSupport;
